export enum Mode {
  View = "view",
  Edit = "edit",
}
